module.exports = __webpack_public_path__ + "static/img/index.1be7c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY-S02/index.png
// module id = 5+w/
// module chunks = 0